export default __webpack_public_path__ + "static/media/NourSarmout.307f414c.jpeg";